import { ChangeEvent } from 'react';
import FormGroup from '../../../../../components/FormGroup';
import Input from '../../../../../components/Input';
import PasswordInputFormGroup from '../../../../../components/PasswordInputFormGroup';
import { GetErrorMessageByFieldNameType } from '../../../../../hooks/useErrors';
import { AsideContainer, Group, Container as StyledContainer } from '../styles';

interface ContactAndAccessInterface {
  getErrorMessageByFieldName: GetErrorMessageByFieldNameType;
  cpf: string;
  handleCpfChange: (event: ChangeEvent<HTMLInputElement>) => void;
  name: string;
  handleNameChange: (event: ChangeEvent<HTMLInputElement>) => void;
  contactCellphone: string;
  handleContactCellphoneChange: (event: ChangeEvent<HTMLInputElement>) => void;
  email: string;
  handleEmailChange: (event: ChangeEvent<HTMLInputElement>) => void;
  emailConfirmation: string;
  handleEmailConfirmationChange: (event: ChangeEvent<HTMLInputElement>) => void;
  password: string;
  handlePasswordChange: (event: ChangeEvent<HTMLInputElement>) => void;
  passwordConfirmation: string;
  handlePasswordConfirmationChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export default function ContactAndAccess({
  getErrorMessageByFieldName,
  cpf,
  handleCpfChange,
  name,
  handleNameChange,
  contactCellphone,
  handleContactCellphoneChange,
  email,
  handleEmailChange,
  emailConfirmation,
  handleEmailConfirmationChange,
  password,
  handlePasswordChange,
  passwordConfirmation,
  handlePasswordConfirmationChange,
}: ContactAndAccessInterface) {
  return (
    <StyledContainer>
      <div className="card-title">
        Dados de contato e acesso
      </div>

      <AsideContainer>
        <Group>
          <div className='title'>CPF</div>
          <FormGroup error={getErrorMessageByFieldName('cpf')}>
            <Input
              placeholder="Informe o CPF"
              value={cpf}
              onChange={handleCpfChange}
              autoComplete="new-password"
              error={getErrorMessageByFieldName('cpf')}
              maxLength={14}
            />
          </FormGroup>
        </Group>
        <Group>
          <div className='title'>Nome</div>
          <FormGroup error={getErrorMessageByFieldName('name')}>
            <Input
              placeholder="Informe o nome do contato"
              value={name}
              onChange={handleNameChange}
              maxLength={25}
              autoComplete="new-password"
              error={getErrorMessageByFieldName('name')}
            />
          </FormGroup>
        </Group>
      </AsideContainer>

      <Group>
        <div className='title'>Celular</div>
        <FormGroup error={getErrorMessageByFieldName('contactCellphone')}>
          <Input
            placeholder="Informe o celular do contato"
            value={contactCellphone}
            onChange={handleContactCellphoneChange}
            autoComplete="new-password"
            maxLength={15}
            error={getErrorMessageByFieldName('contactCellphone')}
          />
        </FormGroup>
      </Group>

      <AsideContainer>
        <Group>
          <div className='title'>E-mail</div>
          <FormGroup error={getErrorMessageByFieldName('email')}>
            <Input
              placeholder="Informe seu e-mail"
              value={email}
              onChange={handleEmailChange}
              autoComplete="new-password"
              error={getErrorMessageByFieldName('email')}
            />
          </FormGroup>
        </Group>
        <Group>
          <div className='title'>Confirmação de e-mail</div>
          <FormGroup error={getErrorMessageByFieldName('emailConfirmation')}>
            <Input
              placeholder="Confirme seu e-mail"
              value={emailConfirmation}
              onChange={handleEmailConfirmationChange}
              autoComplete="new-password"
              error={getErrorMessageByFieldName('emailConfirmation')}
            />
          </FormGroup>
        </Group>
      </AsideContainer>

      <AsideContainer>
        <Group>
          <PasswordInputFormGroup
            label='Senha'
            value={password}
            onChange={handlePasswordChange}
            error={getErrorMessageByFieldName('password')}
          />
        </Group>
        <Group>
          <PasswordInputFormGroup
            label='Confirmação de senha'
            value={passwordConfirmation}
            onChange={handlePasswordConfirmationChange}
            error={getErrorMessageByFieldName('passwordConfirmation')}
          />
        </Group>
      </AsideContainer>
    </StyledContainer>
  );
}
